<template>
  <div v-if="plate">
    <v-checkbox
      :label="`${lead.firstname}, I want to make sure we're  on the same page`"
      v-model="plate.isAgree"
      :error="$v.plate.isAgree.$error"
    />

    <div>
      You NEED life insurance to: Take care of final expenses, you want to make
      sure {{ beneficiary.name }} doesn't have to come out of pocket for the
      {{ finalExpenses.target }}
    </div>

    <v-checkbox
      :error="$v.plate.isKnow.$error"
      :label="`I know ${beneficiary.name}`"
      v-model="plate.isKnow"
    />

    <div v-if="beneficiary.relationship === 'spouse'">
      Is {{ beneficiary.status }}, you want them to focus on you and your memory
      and not have to worry about coming out of pocket. Do I have that right?
    </div>
    <div v-else>
      Gave you {{ beneficiary.grandchildrenAmount }} grandkids and
      {{ beneficiary.liveInSameState ? "won't" : 'will' }}
      have to travel from out of town, but you want them to focus on you and
      your memory and not have to worry about coming out of pocket. Do I have
      that right?
    </div>

    <v-checkbox
      label="Great this is important and I can definitely help out!"
      v-model="plate.isHelp"
      :error="$v.plate.isHelp.$error"
    />

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps, ProtectionTypes } from '@/common/variables';
import { isChecked } from '@/common/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'DisabledNeedsPlate',
  components: { PlateFooter },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({ needs: 'plates/needs' }),
    finalExpenses() {
      return this.needs[ProtectionTypes.finalExpenses];
    },
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.disabledNeeds
    );
    this.plate = data;
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.disabledAnalysis);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setBranch', true);
      this.$store.commit('plates/setStep', PlatesSteps.process);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
  validations: {
    plate: {
      isAgree: { checked: isChecked },
      isKnow: { checked: isChecked },
      isHelp: { checked: isChecked },
    },
  },
};
</script>

<style scoped></style>